export enum SketchActionType {
  Rename = 1,
  Delete = 2,
  CreateCopy = 3,
  Archive = 4,
  CreateNew = 5,
}
